<template>
  <div>
    <div
      class="products-container"
      v-if="cart && cart.products && cart.products.length"
    >
      <div
        class="store-container"
        v-for="storeProducts in getProductsGroupedByStore"
        :key="storeProducts.id"
      >
        <h5>
          {{ "cart.titles.your_orders" | translate }}
          {{ `store.${storeProducts[0].store}` | translate }}
        </h5>
        <div
          class="cart-product-row"
          v-for="product in storeProducts"
          :key="product.id"
        >
          <div
            class="thumbnail"
            :style="{
              backgroundImage: `url(${getProductImageLowRes(
                product.imageSources[0],
                product.store
              )}), url(${product.imageSources[0]})`
            }"
            @click="visitProductPage(product)"
          ></div>
          <div class="info-container">
            <span v-if="product.brand" class="brand">
              {{ product.brand }}
            </span>
            <span class="bold name" @click="visitProductPage(product)">
              {{ product.name }}
            </span>
            <div class="flex">
              <span>
                <span class="bold">{{ "cart.titles.size" | translate }}:</span>
                <span v-if="product.chosenSize">{{ product.chosenSize }}</span>
                <span v-else>One size</span>
              </span>
              <span v-if="product.color">
                <span class="bold">{{ "cart.titles.color" | translate }}:</span>
                <span>{{ product.color }}</span>
              </span>
            </div>
            <div class="flex justify-space-between">
              <div class="flex items-center">
                <button class="button light" @click="addProductToCart(product)">
                  <i class="material-icons">add</i>
                </button>
                <span class="count">{{ product.count }}</span>
                <button
                  class="button light"
                  @click="removeProductFromCart(product)"
                >
                  <i v-if="product.count > 1" class="material-icons">remove</i>
                  <i v-else class="material-icons">delete_outline</i>
                </button>
              </div>

              <div class="flex items-center">
                <div v-if="product.priceSale">
                  <s>{{ product.priceOriginal }}€</s>
                  <span>{{ product.priceSale }}€</span>
                </div>
                <span v-else class="flex mb-0">
                  <span class="mb-0"
                    >{{ "cart.titles.price" | translate }}:
                  </span>
                  <span class="bold mb-0"
                    >CHF {{ product.priceOriginal }}.-</span
                  >
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="shipping">
          <div class="flex justify-space-between">
            <span class="bold"
              >{{ "cart.titles.shipping_cost" | translate }}:
            </span>
            <span class="bold">CHF xx.-</span>
          </div>

          <div class="flex justify-space-between">
            <span class="bold">
              {{ "cart.titles.total_cost" | translate }}:
              {{ `store.${storeProducts[0].store}` | translate }}
            </span>
            <span class="bold">CHF xx.-</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      {{ "cart.titles.no_products" | translate }}
    </div>
  </div>
</template>

<script>
import { cartMethods, productImageResizer } from "../../mixins";
export default {
  name: "cart",
  mixins: [cartMethods, productImageResizer],
  methods: {
    visitProductPage(product) {
      this.$router.push({
        name: "ProductPage",
        params: {
          name: product.name,
          id: product._id,
          sex: this.$route.params.sex
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

$image_width: 6rem;
$image_height: $image_width * 1.35;
.store-container {
  margin-bottom: 1rem;
  background-color: $brand-white;
  padding: 1rem;

  @media (min-width: $breakpoint-md) {
    padding: 1.5rem;
  }

  h5 {
    margin-bottom: 2rem;
  }
}

.shipping {
  margin-left: 7rem;

  @media (min-width: $breakpoint-md) {
    margin-left: 8rem;
  }

  .flex {
    padding-top: 1.5rem;
  }
}

.name {
  cursor: pointer;
}

span {
  font-size: $font-xs;
  margin-right: 0.5rem;
  display: inline;
  margin-bottom: 0.5rem;

  &.bold {
    font-weight: 600;
  }
}

.cart-product-row {
  display: flex;
  position: relative;
  align-items: center;
  border-bottom: 1px solid $brand-black;
  padding: 1.5rem 0;

  .thumbnail {
    width: $image_width;
    height: $image_height;
    min-width: $image_width;
    min-height: $image_height;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    cursor: pointer;
  }

  .info-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-left: 1rem;
    height: $image_height;
    justify-content: space-between;

    @media (min-width: $breakpoint-md) {
      padding-left: 2rem;
    }

    .brand {
      font-family: "Lora";
    }
  }

  .button.light {
    height: 1.5rem;
    width: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .material-icons {
      font-size: $font-xs;
    }
  }
}

.count {
  margin: 0 !important;
  width: 1.5rem;
  display: flex;
  justify-content: center;
}
</style>
